/* eslint-disable max-len */
import { MESSAGES_COUNT_PER_PAGE } from 'Constants/webchat';

import { CONVERSATION_ACTIVE_CONVERSATION } from '../conversationActive/types';

import * as ACTION_TYPES from './types';

const initialState = {
  status: {
    loadingBackward: -1,
    loadingForward: -1,
    loadingGoToTime: -1,
    loadingPrivate: -1,
    loadingPool: -1,
    readMessage: -1,
  },
  bubbleMessages: {},
  pendingMessages: {},
  bufferIds: {},
  jumpMessage: null,
  messageIdByTime: '',
  meta: {
    isLoadMoreBackward: false,
    isLoadMoreForward: false,
    isLoadMorePrivate: false,
  },
  error: null,
  time: Date.now(),
};

export default function reducer(state = initialState, action) {
  const { type, payload, error, meta } = action;

  switch (type) {
    case ACTION_TYPES.MESSAGES_RETRIEVE_BACKWARD_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          loadingBackward: 0,
        },
      };
    case ACTION_TYPES.MESSAGES_RETRIEVE_BACKWARD_SUCCEED: {
      const { conversationId } = action.meta.params;
      const ids = payload.result.data.reverse();
      return {
        ...state,
        bubbleMessages: meta?.isReplace
          ? {
              ...state.bubbleMessages,
              [action.meta.params.conversationId]: ids,
            }
          : {
              ...state.bubbleMessages,
              [action.meta.params.conversationId]: state.bubbleMessages[conversationId]
                ? [...new Set([...ids, ...state.bubbleMessages[conversationId]])]
                : [...ids],
            },
        meta: {
          ...state.meta,
          isLoadMoreBackward: ids.length === MESSAGES_COUNT_PER_PAGE,
        },
        status: {
          ...state.status,
          loadingBackward: 1,
        },
      };
    }
    case ACTION_TYPES.MESSAGES_RETRIEVE_BACKWARD_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          loadingBackward: 2,
        },
        error,
      };

    case ACTION_TYPES.MESSAGES_RETRIEVE_FORWARD_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          loadingForward: 0,
        },
      };
    case ACTION_TYPES.MESSAGES_RETRIEVE_FORWARD_SUCCEED: {
      const ids = payload.result.data;
      const { conversationId } = action.meta.params;
      return {
        ...state,
        bubbleMessages: {
          ...state.bubbleMessages,
          [conversationId]: state.bubbleMessages[conversationId]
            ? [...new Set([...state.bubbleMessages[conversationId], ...ids])]
            : [...ids],
        },
        meta: {
          ...state.meta,
          isLoadMoreForward: ids.length === MESSAGES_COUNT_PER_PAGE,
        },
        status: {
          ...state.status,
          loadingForward: 1,
        },
      };
    }
    case ACTION_TYPES.MESSAGES_RETRIEVE_FORWARD_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          loadingForward: 2,
        },
        error,
      };

    case ACTION_TYPES.MESSAGES_DOCTOR_BACKWARD_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          loadingPrivate: 0,
        },
      };
    case ACTION_TYPES.MESSAGES_DOCTOR_BACKWARD_SUCCEED: {
      const ids = payload.result.data.reverse();
      return {
        ...state,
        meta: {
          ...state.meta,
          isLoadMorePrivate: ids.length === MESSAGES_COUNT_PER_PAGE,
        },
        status: {
          ...state.status,
          loadingPrivate: 1,
        },
      };
    }
    case ACTION_TYPES.MESSAGES_DOCTOR_BACKWARD_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          loadingPrivate: 2,
        },
        error,
      };

    case ACTION_TYPES.MESSAGES_READ_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          readMessage: 0,
        },
      };
    case ACTION_TYPES.MESSAGES_READ_SUCCEED: {
      return {
        ...state,
        status: {
          ...state.status,
          readMessage: 1,
        },
      };
    }
    case ACTION_TYPES.MESSAGES_READ_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          readMessage: 2,
        },
      };

    case ACTION_TYPES.MESSAGE_RECEIVED: {
      const messageId = payload.result.message;
      const message = payload.entities.messages[messageId];
      const {
        metadata: { conversationId },
      } = message;
      return {
        ...state,
        bubbleMessages: {
          ...state.bubbleMessages,
          [conversationId]: state.bubbleMessages[conversationId]
            ? [...new Set([...state.bubbleMessages[conversationId], messageId])]
            : [messageId],
        },
      };
    }
    case ACTION_TYPES.CONVERSATION_CLEAR_MESSAGES: {
      const { conversationId } = payload;
      return {
        ...state,
        bubbleMessages: {
          ...state.bubbleMessages,
          [conversationId]: [],
        },
      };
    }

    case CONVERSATION_ACTIVE_CONVERSATION:
      return {
        ...initialState,
        bubbleMessages: state.bubbleMessages,
        bufferIds: state.bufferIds,
      };

    case ACTION_TYPES.MESSAGES_RETRIEVE_GOTO_TIME_SUCCEED: {
      const { messageId } = payload;
      return {
        ...state,
        messageIdByTime: messageId,
      };
    }

    // get message in pool request
    case ACTION_TYPES.MESSAGES_REQUEST_POOL_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          loadingPool: 0,
        },
      };
    case ACTION_TYPES.MESSAGES_REQUEST_POOL_SUCCEED: {
      const ids = payload.result.data.reverse();
      return {
        ...state,
        status: {
          ...state.status,
          loadingPool: 1,
        },
        pendingMessages: { ...state.pendingMessages, [action.meta.params.consultId]: [...ids] },
      };
    }
    case ACTION_TYPES.MESSAGES_REQUEST_POOL_FAILED: {
      return {
        ...state,
        status: {
          ...state.status,
          loadingPool: 2,
        },
        error,
      };
    }

    case ACTION_TYPES.ADD_BUBBLE_MESSAGE_REQUESTED: {
      return {
        ...state,
        // bubbleMessages: { ...state.bubbleMessages, [payload.id]: payload.messages },
      };
    }
    case ACTION_TYPES.MESSAGE_SET_JUMP_MESSAGE: {
      return {
        ...state,
        jumpMessage: payload.message,
      };
    }

    case ACTION_TYPES.MESSAGE_REMOVE_BY_ID:
      // eslint-disable-next-line no-case-declarations
      const {
        message,
        message: {
          metadata: { conversationId },
        },
      } = payload;
      if (state.bubbleMessages[conversationId]) {
        return {
          ...state,
          bubbleMessages: {
            ...state.bubbleMessages,
            [conversationId]: state.bubbleMessages[conversationId].filter(e => e !== message.id),
          },
        };
      }
      break;

    case ACTION_TYPES.MESSAGES_CLEAR:
      return initialState;
    default:
      return state;
  }
}
